import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { Leistungen } from "@/components/sections/Leistungen";
import { Prozess } from "@/components/sections/Prozess";
import { Galerie } from "@/components/sections/Galerie";
import { Kontakt } from "@/components/sections/Kontakt";

export default function Landing() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Hero />
        <Leistungen />
        <Prozess />
        <Galerie />
        <Kontakt />
      </main>
      <Footer />
    </div>
  );
}